import { render, staticRenderFns } from "./IpList.vue?vue&type=template&id=7267b05d&scoped=true"
import script from "./IpList.vue?vue&type=script&lang=js"
export * from "./IpList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7267b05d",
  null
  
)

export default component.exports